export interface ExportToCsvState {
  isBusy: boolean;
  isError: boolean;
}

export const initialExportToCsvState: ExportToCsvState = {
  isBusy: false,
  isError: false,
};
